import PlotlyChart from './PlotlyChart';

export default function PieChart({ data }) {
  const labels = data[0].x
  const values = data[0].y

  const traces = [
    {
      labels, values,
      type: 'pie',
      name: 'Sales'
    }
  ];

  return (
    <PlotlyChart
      data={traces}
      layout={{ title: 'Sales Over Time' }}
      config={{
        displayModeBar: false,
      }}
      style={{ width: '100%', height: '400px' }}
    />
  );
}
